import { createRoot } from 'react-dom/client';

// Titan One n’a qu’une graisse — ne jamais simuler un gras dessus.
//
// `latin` puis `latin-ext` : le œ de « cœur » et « œillet » n’est PAS dans le
// sous-ensemble latin. Sans latin-ext il retombe sur la police système au
// milieu du mot. Les deux déclarations portent leur `unicode-range` : le fichier
// latin-ext n’est téléchargé que si un tel glyphe apparaît vraiment.
/*
 * Quatre fichiers, pas dix. Literata ne sert qu en 400 — les titres sont deja
 * composes en regulier, une serif n a pas besoin de gras a 34 px — et les sept
 * regles a 700 retombent sur le 600 charge, sans graisse simulee.
 */
import '@fontsource/literata/latin-400.css';
import '@fontsource/literata/latin-ext-400.css';
import '@fontsource/public-sans/latin-400.css';
import '@fontsource/public-sans/latin-ext-400.css';
import '@fontsource/public-sans/latin-600.css';
import '@fontsource/public-sans/latin-ext-600.css';
import './styles/almanach.css';

import { App } from './App.js';
import { FournisseurAppli } from './lib/appli.js';

const racine = document.getElementById('racine');
if (!racine) throw new Error('#racine introuvable');

createRoot(racine).render(
  <FournisseurAppli>
    <App />
  </FournisseurAppli>,
);

/**
 * Service worker : il rend l'application installable et consultable hors ligne.
 * Enregistré après le premier rendu, pour ne pas retarder l'affichage.
 *
 * Absent en développement : un cache de service worker pendant qu'on modifie le
 * code fait perdre plus de temps qu'il n'en gagne.
 */
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js', { scope: '/' });
  });
}
